import styled from 'styled-components'
import { FilterSelectUnstyled } from './unstyled'

export const FilterSelect = styled(FilterSelectUnstyled)`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  height: 40px;
  line-height: 40px;

  label {
    color: ${props => (props.theme.colors || {}).regentGray || '#7F8FA4'};
    font-weight: 600;
    margin-right: 10px;
    width: ${props => (props.label === 'Sort by' ? '50px' : 'auto')};
  }
`
